import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, throwError } from 'rxjs';
import { WidgetMessageService } from '../services/widget-message.service';
import { environment } from '../../../environments/environment';
import { SpinnerService } from '../spinner/service/spinner.service';

export const IS_INTERCEPTING_ENABLED = new HttpContextToken<boolean>(() => true);

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = sessionStorage.getItem('access_token');
  const spinnerService = inject(SpinnerService);
  const widgetService = inject(WidgetMessageService);

  if (!req.context.get(IS_INTERCEPTING_ENABLED)) {
    return next(req);
  }

  // spinnerService.show() is done in BaseCollectionService.getAllWithPagination.
  // we want to show loading only for the data in the overview lists

  const handleError = (error: HttpErrorResponse) => {
    spinnerService.hide();

    if (error.status === 401) {
      console.error('Unauthorized request:', error);
      router.navigate(['login']);
      return throwError(() => error);
    }
    if (environment.isProd) {
      widgetService.setMessage({
        message: `Anfrage mit Fehlercode ${error.status} fehlgeschlagen`,
        messageTye: 'mtError'
      });
    }
    else {
      widgetService.setMessage({
        code: error.status,
        message: error.message,
        messageTye: 'mtError'
      });
    }

    return throwError(() => error);
  };

  const finalizeRequest = () => {
    spinnerService.hide(); // Hide spinner at the end of the request
  };

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next(authReq).pipe(
      catchError(handleError),
      finalize(finalizeRequest) // Ensure finalize is called after every request
    );
  }
  else {
    spinnerService.hide(); // Hide the spinner if no token is present
    router.navigate(['login']);
    return next(req).pipe(
      catchError(handleError)
    );
  }
};
